var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNose6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 41,
    viewBox: "0 0 60 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_5689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0104 4.69702C8.33391 5.15424 0 26.4151 0 26.4151L2.57707 27.0593C3.96952 27.4126 5.3204 27.953 6.48424 28.8051C8.81191 30.4677 10.7863 32.7123 12.3658 34.3749C15.2962 37.4507 20.5542 40.007 29.9896 40.007C39.425 40.007 44.6831 37.4507 47.6134 34.3749C49.1929 32.6915 51.1673 30.4677 53.495 28.8051C54.6588 27.9738 56.0097 27.4126 57.4021 27.0593L59.9792 26.4151C59.9792 26.4151 51.6869 5.15424 30.0104 4.69702Z",
    fill: "#AD775C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 26.4357C60 26.4357 52.8715 0 30.6962 0C8.52096 0 0 26.4357 0 26.4357H4.38517C7.3779 26.4357 10.3083 27.5372 12.3658 29.6986C15.2962 32.7745 20.5542 35.3308 29.9896 35.3308C39.425 35.3308 44.6831 32.7745 47.6134 29.6986C49.6709 27.5372 52.6013 26.4357 55.594 26.4357H59.9792H60Z",
    fill: "#E6AB87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8039 25.9786C40.4324 25.9786 42.5632 24.3502 42.5632 22.3416C42.5632 20.3329 40.4324 18.7046 37.8039 18.7046C35.1755 18.7046 33.0447 20.3329 33.0447 22.3416C33.0447 24.3502 35.1755 25.9786 37.8039 25.9786Z",
    fill: "#F1B89B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_5689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40.0277,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose6);
export default __webpack_public_path__ + "static/media/nose-6.30e05d51834d90dccb1f2d8a7fe227ce.svg";
export { ForwardRef as ReactComponent };